import React from 'react';

import { Row, Col } from 'antd';
import Input from 'components/Common/Form/Input/Input';
import CheckBox from 'components/Common/Form/Checkbox';
import { Container } from './styles';

interface IObservacoes {
	exigenciasObservacao: string[];
	exigenciaObservacao: boolean;
}

interface IData {
	data: IObservacoes;
}

const Observacoes: React.FC<IData> = ({ data }) => {
	return (
		<Container>
			<Row gutter={[15, 5]}>
				<Col span={24}>
					<CheckBox
						name="observacoes"
						checked={!!data?.exigenciaObservacao}
						onChange={() => {}}
						disabled
						subtitle="Observações"
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={24}>
					<Input
						name="exigObservacao01"
						value={
							(data?.exigenciasObservacao && data.exigenciasObservacao[0]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={24}>
					<Input
						name="exigObservacao02"
						value={
							(data?.exigenciasObservacao && data.exigenciasObservacao[1]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={24}>
					<Input
						name="exigObservacao03"
						value={
							(data?.exigenciasObservacao && data.exigenciasObservacao[2]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={24}>
					<Input
						name="exigObservacao04"
						value={
							(data?.exigenciasObservacao && data.exigenciasObservacao[3]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={24}>
					<Input
						name="exigObservacao05"
						value={
							(data?.exigenciasObservacao && data.exigenciasObservacao[4]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={24}>
					<Input
						name="exigObservacao06"
						value={
							(data?.exigenciasObservacao && data.exigenciasObservacao[5]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={24}>
					<Input
						name="exigObservacao07"
						value={
							(data?.exigenciasObservacao && data.exigenciasObservacao[6]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={24}>
					<Input
						name="exigObservacao08"
						value={
							(data?.exigenciasObservacao && data.exigenciasObservacao[7]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={24}>
					<Input
						name="exigObservacao09"
						value={
							(data?.exigenciasObservacao && data.exigenciasObservacao[8]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={24}>
					<Input
						name="exigObservacao10"
						value={
							(data?.exigenciasObservacao && data.exigenciasObservacao[9]) || ''
						}
						disabled
					/>
				</Col>
			</Row>
		</Container>
	);
};

export default Observacoes;
